/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authorized_Apps_SubtitleInputs */



/**
* | output |
* | --- |
* | "Third-party apps you've granted access to your Archon account." |
*
* @param {Authorized_Apps_SubtitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const authorized_apps_subtitle = /** @type {((inputs?: Authorized_Apps_SubtitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authorized_Apps_SubtitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Applications tierces auxquelles vous avez accordé l'accès à votre compte Archon.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aplicaciones de terceros a las que ha concedido acceso a su cuenta de Archon.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Aplicativos de terceiros aos quais você concedeu acesso à sua conta Archon.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Applicazioni di terze parti a cui ha concesso l'accesso al suo account Archon.")
	return /** @type {LocalizedString} */ ("Third-party apps you've granted access to your Archon account.")
});